import React, { useRef,useState } from "react";

// core components
import QrReader from 'react-qr-reader';

const QRReader = (props) => {
const [camera, setCamera] = useState(true);
const qrRef = useRef(null);

  const handleError = (error)=>{
      console.log(error);
  }
  const handleScan = async (result)=>{
      if(result){
        setCamera(false)
        props.order(result)
      }
  }

  return (
    <>
    
            <QrReader
            ref={qrRef}
            delay={500}
            onError={handleError}
            onScan={handleScan}
            />
          
    </>
  );
};

export default QRReader;
